import * as e from "react";
const m = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.2L12 13.2 9.8 11H11zm-6 7h14v2H5v-2z" }));
export {
  m as ReactComponent
};
